import React from 'react';
import theme from './ZipFileDownload.module.scss';
import { useParams } from 'react-router';
import { getZipDownloadUrl } from '@/services/documents';
import { Trans } from '@lingui/react/macro';
import { ExternalLinkButton } from '@/components/Buttons';
import { faFileArchive } from '@fortawesome/pro-light-svg-icons';

interface ZipFileDownloadProps {}

/**
 * Currently not in use
 */
const ZipFileDownload: React.FC<ZipFileDownloadProps> = (props) => {
    const { downloadId } = useParams<{ downloadId: string }>();

    return (
        <div className={theme.container}>
            <h3>
                <Trans>Your zip file is ready to download. </Trans>
            </h3>
            <ExternalLinkButton icon={faFileArchive} color="primary" href={getZipDownloadUrl(downloadId)}>
                <Trans>Download zip file</Trans>
            </ExternalLinkButton>
        </div>
    );
};

export default ZipFileDownload;
